var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobFee = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9969 40.2902C65.5794 47.6365 63.024 57.4407 57.0705 61.5833C51.1442 65.7535 41.8469 64.2346 35.1865 59.2634C28.5262 54.3199 24.4756 45.869 26.5417 39.2684C28.5805 32.6954 36.7361 27.9452 44.7013 28.0005C52.6393 28.0557 60.4143 32.944 62.9969 40.2902Z",
    fill: "#FA7B6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8697 27.8609C28.0091 27.1144 29.6743 26.6652 31.8985 26.6652C34.1432 26.6652 35.849 27.1705 37.0239 27.9291C38.1735 28.6712 38.9002 29.7273 38.9002 30.8061H37.1002C37.1002 30.5503 36.8913 29.986 36.0476 29.4413C35.2294 28.913 33.8844 28.4652 31.8985 28.4652C29.8922 28.4652 28.6083 28.8738 27.8561 29.3665C27.1173 29.8505 26.9002 30.399 26.9002 30.8061C26.9002 31.6051 26.931 32.1897 27.3845 32.6588C27.8583 33.1488 29.0129 33.7189 31.8985 33.7189C35.0256 33.7189 36.8624 34.3455 37.8835 35.3983C38.9019 36.4483 38.9008 37.7222 38.9002 38.3868C38.9002 38.4021 38.9002 38.4171 38.9002 38.4317C38.9002 39.2526 38.674 40.5211 37.5917 41.5779C36.5109 42.6331 34.7216 43.3352 31.8985 43.3352C29.1104 43.3352 27.3761 42.745 26.3375 41.8207C25.2706 40.8713 25.1002 39.7178 25.1002 39.0037L26.9002 39.0037C26.9002 39.4334 26.9942 39.9957 27.5341 40.476C28.1022 40.9816 29.3171 41.5352 31.8985 41.5352C34.4449 41.5352 35.7064 40.9029 36.3342 40.29C36.9603 39.6786 37.1002 38.9454 37.1002 38.4317C37.1002 37.748 37.0751 37.1502 36.5914 36.6515C36.0871 36.1315 34.8731 35.5189 31.8985 35.5189C28.8858 35.5189 27.0913 34.9451 26.0905 33.91C25.0978 32.8833 25.0993 31.6055 25.1001 30.868C25.1002 30.8469 25.1002 30.8263 25.1002 30.8061C25.1002 29.688 25.7169 28.6161 26.8697 27.8609Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3934 27.3744V24H33.1934V27.3744H31.3934Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3934 46.0001V42.6257H33.1934V46.0001H31.3934Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1001 34C51.1001 23.4513 42.5487 14.9 32.0001 14.9V13.1C43.5428 13.1 52.9001 22.4572 52.9001 34C52.9001 45.5427 43.5428 54.9 32.0001 54.9C20.4573 54.9 11.1001 45.5427 11.1001 34C11.1001 28.5742 13.1688 23.6296 16.5589 19.915L17.8885 21.1284C14.7891 24.5243 12.9001 29.0405 12.9001 34C12.9001 44.5486 21.4515 53.1 32.0001 53.1C42.5487 53.1 51.1001 44.5486 51.1001 34Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2871 14.194L36.9342 10.6291L35.647 9.37085L30.7127 14.194L35.647 19.0172L36.9342 17.759L33.2871 14.194Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobFee);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlobFee.a42d8878421fa7390fa4329f097efc5a.svg";